<template>
  <div class="main-container min-h-screen md:min-h-full lg:min-h-screen">
    <div>
      <hamburger-menu
        :sticky-top="false"
        :step-name="stepName"
        :available-carrier-elected="hasAvailableCarrierElectedClassifications"
        :next-step="nextStep2"
        :form-position="formPosition"
        :saved-index="savedIndex"
      >
        <!-- <template #backButton>
          <div 
            class="w-16 md:w-48"
            :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
          >
            <div 
              v-show="isMounted && stepName !== 'Classifications' && !(hasAvailableCarrierElectedClassifications == false && stepName == 'Identity-1')"
              class="backButtonHeader w-16 md:w-48 flex"
              :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
            >
            </div>
            
          </div>
        </template> -->
        <!-- <div 
          class="w-16 md:w-48"
          :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
        >
          <div 
            v-show="stepName !== 'Classifications' && !(hasAvailableCarrierElectedClassifications == false && stepName == 'Identity-1')"
            class="backButtonHeader w-16 md:w-48 flex"
            :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
          >
          </div>
          
        </div> -->
        <template #navButtons>
          <div class="w-16 text-right md:w-48">
            <div class="flex cursor-pointer items-center justify-end">
              <button
                v-if="
                  hasAvailableCarrierElectedClassifications == true &&
                  stepName !== 'Classifications'
                "
                class="small-sm-text flex items-center text-right text-1md text-gray-over-dark md:mr-8 md:text-center"
                variant="link"
                @click="redirectToClassifications"
              >
                Classifications
              </button>
              <button
                v-else-if="
                  hasAvailableCarrierElectedClassifications == true &&
                  stepName == 'Classifications' &&
                  savedIndex !== null
                "
                class="small-sm-text flex items-center text-right text-1md text-gray-over-dark md:mr-8 md:text-center"
                variant="link"
                @click="nextStep(savedIndex, true)"
              >
                Return
              </button>
              <button
                class="invisible flex items-center text-1md text-gray-over-dark md:visible"
                variant="link"
                @click="openNeedHelpModal"
              >
                Help
                <img
                  class="ml-1 mr-5 h-3 w-3 sm:ml-3"
                  src="@/assets/gray-question-mark.svg"
                  alt="question mark"
                />
              </button>
              <button
                class="invisible ml-5 flex items-center whitespace-nowrap text-1md text-gray-over-dark md:visible"
                variant="link"
                @click="logOut()"
              >
                Log Out
              </button>
            </div>
          </div>
        </template>
      </hamburger-menu>
    </div>
    <div
      v-if="
        !loading && availableCarrierElectedClassificationsHaveLoaded == true
      "
      class="tablet-desktop-container flex w-full flex-col justify-between overflow-scroll pt-12 md:mx-auto md:max-w-2xl md:overflow-hidden"
    >
      <div class="scrollbar-visible flex-grow overflow-scroll">
        <form-flow
          :form-position="formPosition"
          :next-step="nextStep2"
          :step-types="steps"
          :skip-step="skipStep"
          :back-step="backStep2"
          :data="$store.state.carriers.carrierData"
          :update-field="updateField"
          :beginning-step="beginningStep"
          :step-name="stepName"
          :button-loading="buttonLoading"
          :trigger-loading-btn="triggerLoadingBtn"
          :handle-w8-submit="handleW8Submit"
          @exit-modal="openSaveModal"
        />
      </div>
      <div
        id="formNavigationButtons"
        class="footer-container md:w-full md:max-w-3xl md:px-6"
      />
    </div>
    <div
      v-else
      class="tablet-desktop-container mx-auto flex h-screen max-w-2xl items-center justify-center overflow-scroll pt-12 md:h-80 md:overflow-hidden"
    >
      <img
        class="-top-2px loading relative h-12 w-full"
        src="@/assets/loading-v2-yellow.svg"
        alt=""
      />
    </div>
  </div>
  <save-and-quit-modal
    v-if="showSaveModal"
    :visible="showSaveModal"
    @close="onCloseSaveModal"
    @quit="beginningStep"
  />
  <need-help-modal
    v-if="showNeedHelpModal"
    :visible="showNeedHelpModal"
    @close="onCloseNeedHelpModal"
  />
  <ConfirmYourOwnership
    :hide-button="true"
    :trigger-flow="openConfirmOwnershipModal"
    :enforce-validation="true"
    @exec-next-step="() => {}"
  />
</template>

<script>
// @ is an alias to /src
import { ref } from 'vue';
import { mapGetters } from 'vuex';
import FormFlow from '@/components/FormFlow.vue';
import stepOrder from '@/common/stepOrder';
import SaveAndQuitModal from '@/components/modals/SaveAndQuitModal.vue';
import { toastResponse } from '@/common/handleServerResponse';
import needHelp from '@/mixins/needHelp';
import HamburgerMenu from '@/components/HamburgerMenu.vue';
import ConfirmYourOwnership from '@/components/ConfirmYourOwnership.vue';

export default {
  name: 'Home',
  components: {
    FormFlow,
    SaveAndQuitModal,
    HamburgerMenu,
    ConfirmYourOwnership,
  },
  mixins: [needHelp],
  data() {
    return {
      isMounted: false,
      previousStep: null,
      currentStep: null,
      openConfirmOwnershipModal: false,
      // formPosition: this.hasAvailableCarrierElectedClassifications == true ? 0 : 1,
      steps: [],
      data: {},
      // stepName: this.hasAvailableCarrierElectedClassifications == true ? "Classifications" : "Identity-1", /** initial step */
      // allowNextStep: [
      //   "Identity-2",
      //   "Operations",
      //   "Lanes",
      //   "Certifications-2",
      //   "Insurance-4",
      //   // "Payment-4",
      //   "Questions",
      //   "Integrations",
      // ],
      savedNextStep: null,
      savedIndex: null,
      buttonLoading: false,
      screenSize:
        window.innerWidth >= 640
          ? window.innerWidth <= 1024
            ? 'tablet'
            : 'desktop'
          : 'mobile',
    };
  },
  computed: {
    carrierId() {
      return (
        this.$store.state.users.currentUser?.company?.carrier_id ||
        this.$store.state.users.currentUser?.requested_carrier_id ||
        this.$store.state.carriers?.carrierData?.identity.id
      );
    },
    issuerId() {
      return this.$store.state.carriers.carrierData?.connection?.issuer?.id;
    },
    ownershipData() {
      return this.$store.state.ownership.ownershipData;
    },
    selectOnboardingOrderSteps() {
      if (!this.$store.getters['shouldEnableCHRFlow']) return stepOrder;

      const ownershipSteps = [
        {
          title: 'Ownership',
          step: 8,
          subStep: 1,
          subStepTotal: 2,
          identifier: 'Ownership-1',
          stage: 'Ownership',
        },
        {
          title: 'Ownership',
          step: 8,
          subStep: 2,
          subStepTotal: 2,
          identifier: 'Ownership-2',
          stage: 'Ownership',
        },
      ];

      const integrationsIndex = stepOrder.findIndex(
        (step) => step.stage === 'Integrations'
      );
      if (integrationsIndex !== -1) {
        stepOrder.splice(integrationsIndex, 1, ...ownershipSteps);
      }
      return stepOrder;
    },
    formPosition() {
      return this.$store.state.formRoutes?.activeStepIndex;
    },
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
    ...mapGetters('insurance', ['getHasFileCargo', 'getHasFileAuto']),
    hasFileCargo() {
      return this.getHasFileCargo;
    },
    isActiveTruckerTool() {
      return this.$store.state.integrations?.truckerTools?.isActive;
    },
    hasFileAuto() {
      return this.getHasFileAuto;
    },
    isTriumphPayAllowed() {
      let isAllowed = false;
      this.$store.state.payments.payment_terms.forEach((term) => {
        term.allowed_payment_methods.forEach((allowed) => {
          if (allowed === 'triumph_pay') {
            isAllowed = true;
          }
        });
      });

      return isAllowed;
    },
    renderedPayment() {
      if (this.$store.state.payments.rendered_payment === null) {
        return false;
      } else {
        return (
          this.$store.state.payments.rendered_payment?.[0] ||
          this.$store.state.payments.rendered_payment
        );
      }
    },
    hasCompletedCarrierElectedClassificationsStage() {
      return this.$store.state.carriers
        ?.hasCompletedCarrierElectedClassificationsStage;
    },
    companyType() {
      return this.$store.state.users.currentUser.company.company_type;
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    onboardingPacket() {
      return this.$store.state.onboardingPacket;
    },
    broker_connect_channels() {
      return this.$store.state.onboardingPacket?.broker_connect_channels;
    },
    company_question_sections() {
      return this.$store.state.carriers?.carrierData?.company_question_sections;
    },
    hasAvailableCarrierElectedClassifications() {
      if (
        this.$store.state.carriers?.availableCarrierElectedClassifications
          ?.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    availableCarrierElectedClassificationsHaveLoaded() {
      return this.$store.state.carriers
        ?.availableCarrierElectedClassificationsHaveLoaded;
    },
    auto_skip_stage_six() {
      return this.$store.state.carriers?.carrierData?.auto_skip_stage_six;
    },
    auto_skip_stage_seven() {
      if (this.$store.state.carriers?.carrierData?.auto_skip_stage_seven) {
        return true;
      } else if (
        this.$store.state.questions?.total_sections == 0 &&
        this.stepName?.includes('Questions') &&
        (this.$store.state.carriers?.carrierData?.payment_method?.id > 0 ||
          this.$store.state.carriers?.carrierData?.factor?.id > 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
    triumphPayDeclined() {
      return this.$store.state.payments.triumph_pay_declined;
    },
    paymentTerms() {
      return [...(this.$store.state.payments?.payment_terms ?? [])];
    },
    paymentTermsNonFactoring() {
      return this.paymentTerms?.filter((term) => term?.is_type !== 'factoring');
    },
    activePaymentMethodsDestructured() {
      return [...(this.$store.state.payments?.activePaymentMethods ?? [])];
    },
    brokerLink() {
      return this.$store.state.carriers?.carrierData?.connection?.issuer
        ?.sign_in_with_highway_link;
    },
  },
  watch: {
    formPosition: function () {
      window.scrollTo(0, 0);
    },
    '$store.state.carriers.carrierData': async function (val) {
      if (Object.keys(val).length > 0) {
        this.steps = this.selectOnboardingOrderSteps;
        const stepsWithFirstTimeIdentifier = this.steps.map((step) => ({
          ...step,
          firstTimeIdentifier: step.stage,
        }));
        this.$store.commit('formRoutes/setSteps', stepsWithFirstTimeIdentifier);
        let allowedW8IsTypes = val?.connection?.issuer?.allowed_w8_is_types;
        let latest_tax_form_type =
          val?.latest_tax_form_submission?.tax_form_is_type;
        if (allowedW8IsTypes?.length > 0) {
          if (
            latest_tax_form_type &&
            allowedW8IsTypes.includes(latest_tax_form_type)
          ) {
            await this.$store.commit('firstTime/updateStepFirstTime', {
              step: 'Contract',
              value: false,
            });
          } else {
            await this.$store.commit('firstTime/updateStepFirstTime', {
              step: 'Contract',
              value: true,
            });
          }
        }
        this.$store.commit('loading/loadingToggleOff', null, {
          root: true,
        });
        if (
          this.$store.state.carriers
            .availableCarrierElectedClassificationsHaveLoaded == false
        ) {
          await this.$store.dispatch(
            'carriers/getAvailableCarrierElectedClassifications'
          );
          await this.$store.dispatch(
            'carriers/getCurrentCarrierElectedClassifications'
          );
        }
        if (
          val?.connection?.issuer_id > 0 &&
          this.$store.state.onboardingPacket?.broker_connect_channels == null
        ) {
          // console.log('running getBrokerConnectChannels from carrierData watch');
          this.$store.dispatch(
            'onboardingPacket/getBrokerConnectChannels',
            val?.connection?.issuer_id
          );
        }

        this.$store.dispatch('insurance/getPolicy', this.carrierId);

        this.autoClaimControllingManager();
        this.checkTrackingParams();
      }
    },
    // availableCarrierElectedClassificationsHaveLoaded: {
    //   handler(newVal, oldVal) {
    //     let self = this;
    //     if (newVal == true && oldVal == false) {
    //       if (self.hasAvailableCarrierElectedClassifications == true) {
    //         this.formPosition = 0;
    //         this.stepName = 'classifications';
    //       }
    //       // else {
    //       //   this.formPosition = 1;
    //       //   this.stepName = 'identity';
    //       // }
    //     }
    //   },
    //   immediate:true
    // },
    triumphPayDeclined: function () {
      // const tPayMethods = this.$store.state.payments?.activePaymentMethods?.filter(payment => payment?.is_type === 'triumph_pay');
      // const carrierRate = tPayMethods.some(pay => Number(pay.triumph_pay_select_carrier_rate) > 0);
      // if(carrierRate){
      //   const { search } = window.location;
      //   const updatedHash =  this.steps[this.formPosition]?.identifier?.toLowerCase();
      //   this.stepName = this.steps[this.formPosition]?.identifier;
      //   window.history.pushState(null, null, `${search}#${updatedHash}`);
      // }
    },
  },
  async created() {
    await this.$store.dispatch(
      'payments/getPaymentTerms',
      this.$route.params.id
    );

    // const { pathname } = window.location;
    // const split = pathname.split("onboarding_packets/");

    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });

    let result = await this.$store.dispatch(
      'onboardingPacket/getOnboardingPacketById',
      {
        id: this.$route.params.id,
      }
    );
    if (result.status == 403) {
      console.log('get onboarding packet returned a 403');
      toastResponse(this, result, null);
    }

    const clientId =
      this.extractClientId(
        result?.data?.connection?.issuer?.sign_in_with_highway_link
      ) ||
      this.extractClientId(this.brokerLink) ||
      localStorage.getItem('client_id');
    console.log('clientId', clientId);
    if (!localStorage.getItem('client_id')) {
      localStorage.setItem('client_id', clientId);
    }
    if (this.extractClientId(this.brokerLink) !== clientId) {
      this.$store.dispatch('brokers/updateLocalStorage', this.brokerLink);
    }
    await Promise.all([
      this.$store.dispatch('company/getCompanyByClientId', clientId),
      this.$store.dispatch('payments/getActivePaymentMethods'),
      this.$store.dispatch('payments/getLatestPaymentMethod'),
    ]);

    if (this.$store.getters['shouldEnableCHRFlow']) {
      await this.$store.dispatch(
        'ownership/getOwnershipByCompanyId',
        this.$store.state.users.currentUser.company.id
      );
    }
    if (this.onboardingPacket.status != 'incomplete') {
      switch (this.companyType) {
        case 'dispatcher':
          // Dispatchers don't follow the OAuth 2 flow, they go to a status
          // Screen for the packet
          console.log(
            'onboarding packet completed; sending to dispatcher status'
          );
          return this.$router.push({
            name: 'Dispatcher Onboarding Packet Status',
            params: { id: this.onboardingPacket?.id },
          });
        case 'broker':
        case 'carrier':
          console.log('onboarding packet completed; sending to carrier status');
          return this.$router.push({
            name: 'Carrier Onboarding Packet Status',
            params: { id: this.onboardingPacket?.id },
          });
      }
    }
    if (localStorage.getItem('country_iso2')?.length > 0) {
      this.$store.commit(
        'users/setPreferredCountry',
        localStorage.getItem('country_iso2')
      );
    }
    // const payment = this.activePaymentMethodsDestructured?.length > 0 ? this.activePaymentMethodsDestructured.filter(payment => payment.is_type === 'triumph_pay') : [];
    // if(payment?.length > 0){
    //   if(this.$store.state.payments.payment_term?.is_type === 'factoring'){
    //     console.log('Setting Factor')
    //     return;
    //   }
    // //  let  paymentTermId = this.$store.state.payments.payment_terms?.filter(payment => payment?.allowed_payment_methods?.includes('triumph_pay'));
    // //  paymentTermId = paymentTermId?.[0]?.id;
    //   if(this.isPaymentMethodAllowed('triumph_pay') && Number(payment?.[0]?.triumph_pay_select_carrier_rate) > 0){
    //     console.log('setting Triumph Pay as method');
    //     const paymentTermsAllowingTriumphPay = this.paymentTermsNonFactoring.filter(term => term?.allowed_payment_methods?.includes('triumph_pay'));
    //     const quickPayTerms = paymentTermsAllowingTriumphPay.filter(term => term?.is_type == 'quick_pay');
    //     if (quickPayTerms?.length > 0) {
    //       this.$store.commit('payments/setPaymentType', { paymentTerm: 'quick_pay', paymentTermId: quickPayTerms?.[0]?.id } );
    //       this.$store.commit('payments/setSelectedPaymentTerm', quickPayTerms?.[0]);
    //       this.$store.dispatch('payments/getLatestAllowedPaymentMethod', quickPayTerms?.[0]);
    //     } else {
    //       this.$store.commit('payments/setPaymentType', { paymentTerm: paymentTermsAllowingTriumphPay?.[0]?.is_type, paymentTermId: paymentTermsAllowingTriumphPay?.[0]?.id } );
    //       this.$store.commit('payments/setSelectedPaymentTerm', paymentTermsAllowingTriumphPay?.[0]);
    //       this.$store.dispatch('payments/getLatestAllowedPaymentMethod', paymentTermsAllowingTriumphPay?.[0]);
    //     }
    //   }
    // }

    // if(this.$store.state.payments?.payment_source !== '' && this.$store.state.payments?.payment_source !== 'triumph_pay' ){
    //   // console.log('Its coming here!')
    //   this.$store.commit('payments/setTriumphPayDeclined', true);
    // }

    window.onpopstate = () => {
      // this.backStep();
    };
  },

  async beforeMount() {
    const { search, hash } = window.location;
    window.history.pushState(null, null, `${search}${hash}`);

    const findCurrentStep = this.steps.find(
      (el) => el?.identifier?.toLowerCase() === hash?.replace('#', '')
    );

    if (this.stepName === 'Integrations' || findCurrentStep == 'integrations') {
      console.log('isintegrationsStep is true');
      this.$store.commit('isIntegrationsStep', true);
    }
    // if (this.$store.state.integrationsStep && broker_connect_channels?.length < 1) {

    // } else
    if (findCurrentStep) {
      window.history.pushState(
        null,
        null,
        `${search}#${findCurrentStep?.identifier?.toLowerCase()}`
      );
    }
    // await this.$store.dispatch("carriers/getAvailableCarrierElectedClassifications");
    // this.$router.replace({
    //   query: { id: this.$store.state.onboardingPacket.onboarding_id },
    // });
  },
  mounted() {
    this.isMounted = true;

    addEventListener('resize', () => {
      switch (true) {
        case window.innerWidth <= 640:
          return (this.screenSize = 'mobile');
        case window.innerWidth <= 1024:
          return (this.screenSize = 'tablet');
        default:
          return (this.screenSize = 'desktop');
      }
    });
  },
  methods: {
    async checkTrackingParams() {
      try {
        const companyId =
          this.$store.state.carriers.carrierData?.connection?.issuer?.id;
        const res = await this.$store.dispatch(
          'onboardingPacket/getTrackingConfigsByCompanyId',
          companyId
        );
        const trackingConfigs = res?.data ?? [];

        const validConfigs = trackingConfigs
          .map(({ is_type, field_name }) => {
            const value = localStorage.getItem(field_name);
            if (!value) return null;
            return { is_type, field_name, value };
          })
          .filter(Boolean);

        if (validConfigs.length === 0) return;

        const createEntryPromises = validConfigs.map(({ is_type, value }) =>
          this.$store.dispatch('onboardingPacket/createTrackingConfigs', {
            is_type,
            value,
            onboardingPacketId: this.onboardingPacket?.id,
          })
        );

        await Promise.all(createEntryPromises);

        validConfigs.forEach(({ field_name }) =>
          localStorage.removeItem(field_name)
        );
      } catch (error) {
        console.error('Failed to create tracking entries:', error);
      }
    },
    async autoClaimControllingManager() {
      // Exit early if criteria are not met
      if (
        this.issuerId != import.meta.env.VITE_LOADPAY ||
        !this.$store.getters['shouldEnableCHRFlow']
      ) {
        return;
      }

      await this.ensureOwnershipCompanyExists();

      const { currentUser } = this.$store.state.users;
      const ownershipUsers = this.ownershipData?.ownership_users ?? [];
      const existingOwner = ownershipUsers.find(
        (user) => user.user_id === currentUser.id
      );

      // If the ownership user is already the controlling manager, exit early
      if (
        existingOwner?.is_type === 'controlling_manager' &&
        existingOwner.status == 'complete'
      ) {
        return;
      }

      this.openConfirmOwnershipModal = true;
    },
    async ensureOwnershipCompanyExists() {
      const companyId = this.$store.state.users.currentUser.company.id;

      const ownership = await this.$store.dispatch(
        'ownership/getOwnershipByCompanyId',
        companyId
      );

      if (!ownership) {
        console.log('Company not found, proceeding to create it.');
        await this.$store.dispatch('ownership/createOwnershipCompany', {
          companyId,
        });
      }
    },
    redirectToClassifications() {
      this.$store.commit('formRoutes/setRedirectToClassifications', true);
    },
    async logOut() {
      const logoutRes = await this.$store.dispatch('users/userSignOut');
      if (logoutRes) {
        this.$router.push({ name: 'SignUp' });
      }
    },
    extractClientId(url) {
      const regex = /client_id=([^&]*)/i;
      const match = url?.match(regex);
      if (match) {
        return match?.[1];
      } else {
        return null;
      }
    },
    async handleW8Submit() {
      console.log('handleW8Submit');
      this.triggerLoadingBtn(true);
      let res = await this.$store.dispatch('taxQuestions/submitTaxForm');
      toastResponse(this, res, 'Tax form successfully submitted');
      if ([200, 201].includes(res?.status)) {
        this.$store.commit('updateStepFirstTime', {
          step: 'Contract',
          first_time: false,
        });
      }
      this.triggerLoadingBtn(false);
    },
    isPaymentMethodAllowed(requestedPaymentMethod) {
      return this.paymentTermsNonFactoring?.some((term) =>
        term?.allowed_payment_methods?.includes(requestedPaymentMethod)
      );
    },
    triggerLoadingBtn(state = true) {
      this.buttonLoading = state;
    },
    // Determine if we can hit the next step or not based on the currentStep and the nextStep which
    // comes from the updatePacket method.  Before changing this, talk to Lawson.
    async determineIfCanHitNextStep(currentStep, nextStep) {
      const { stage } = this.$store.state.carriers.carrierData;
      // Validate that the current step of the form is equal to the current stage_name in the onboarding packet
      // Check that the next step should be hit (not a sub step)
      // otherwise, do not hit the next step
      console.log(
        'currentStep.step',
        currentStep?.step,
        'stage',
        stage,
        'nextStep.step',
        nextStep?.step
      );
      return nextStep.step > currentStep.step && nextStep.step > stage;
    },
    // async updatePacket(currentStep, canHitNextStep) {
    //   console.log('updatePacket', currentStep?.identifier, canHitNextStep);
    //   const onboarding_id = this.$store.state.carriers?.carrierData?.id;
    //   // const { stage_name } = this.$store.state.carriers.carrierData;
    //   // const { stage } = this.$store.state.carriers.carrierData;
    //   /*
    //     * We will use this variable to make the second call to the /next endpoint
    //     * when the question section is first skipped.
    //    */

    //   // Determine if we canHitNextStep
    //   // Start with the default of false
    //   // let canHitNextStep = await this.determineIfCanHitNextStep(currentStep);
    //   // console.log('canHitNextStep', canHitNextStep)
    //   // Find request payload body -- if exists submit update to onboarding packet
    //   if (
    //     Object.entries(this.$store.state.onboardingPacket.onboardingPacketBody)
    //       .length > 0
    //   ) {
    //     console.log('updates to onboarding packet present; submitting to server')
    //     const res = await this.$store.dispatch(
    //       "onboardingPacket/updatePacket",
    //       {
    //         id: onboarding_id,
    //         body: {
    //           ...this.$store.state.onboardingPacket.onboardingPacketBody,
    //         },
    //         canHitNextStep,
    //       }
    //     );
    //     return res;
    //   } else if (canHitNextStep) {
    //     console.log('no updates to onboarding packet present and CAN hit next step')
    //     // If no change was made to the onboarding packet, the next step should hit if available
    //     const nextStepRes = await this.$store.dispatch(
    //       "onboardingPacket/nextStepPatch",
    //       {
    //         id: onboarding_id,
    //       }
    //     );
    //     console.log('SERVER IS NOW ON STAGE',nextStepRes?.data?.stage)
    //     return nextStepRes;
    //   } else {
    //     console.log('no updates to onboarding packet and do not need to hit next step')
    //     // not hitting next step but need to transition to next sub step
    //     return { status: 200 };
    //   }
    // },

    async nextStep2(
      // eslint-disable-next-line
      index = 1,
      // eslint-disable-next-line
      initialHit = false,
      // eslint-disable-next-line
      routeToClassifications = false
    ) {
      return;
    },
    /*async nextStep(index = 1, initialHit = false, routeToClassifications = false) {
      this.buttonLoading = true;
      console.log('HITTING NEXT STEP', index, initialHit)
      const { search } = window.location;
      if (initialHit == true) {
        if (this.availableCarrierElectedClassificationsHaveLoaded == false) {
          console.log('retrieving available carrier elected classifications');
          await this.$store.dispatch("carriers/getAvailableCarrierElectedClassifications");
          await this.$store.dispatch("carriers/getCurrentCarrierElectedClassifications");
          console.log('availableCarrierElectedClassificationsHaveLoaded', this.availableCarrierElectedClassificationsHaveLoaded);
        }
        if (this.hasAvailableCarrierElectedClassifications == false) {
          console.log('no carrier-elected classifications available; skipping to Identity-1');
          console.log('initial hit on identity step - decrementing nextStep index value by 1');
          index = index - 1;
          this.savedNextStep = null;
        } else if (this.hasCompletedCarrierElectedClassificationsStage == false || routeToClassifications == true) {
          // reroute to carrier-elected classifications and save the nextStep and index
          console.log('carrier-elected classifications available; rerouting to classifications');
          this.savedNextStep = this.steps[this.formPosition + index];
          this.savedIndex = index;
          if (routeToClassifications == true) {
            this.savedNextStep = this.steps[index];
            this.stepName = 'classifications';
            this.formPosition = 0;
          }
          this.updateUrlPath(0, `${search}#classifications`, 'classifications');
          return;
        }
      } else {
        if (this.savedIndex !== null && this.savedNextStep !== null && this.savedNextStep?.identifier?.length > 0) {
          console.log('rerouting to savedNextStep');
          const savedPath = `${search}#${this.savedNextStep?.identifier?.toLowerCase()}`;
          const savedIndex = this.savedIndex;
          const savedNextStep = this.savedNextStep;
          console.log('rerouting to savedNextStep', savedPath, savedIndex, savedNextStep);
          if(savedPath === '#payment-1' && (this.renderedPayment?.is_type === 'triumph_pay'  &&  Number(this.renderedPayment?.triumph_pay_select_carrier_rate)) > 0 && this.isTriumphPayAllowed){
            console.log('Redirecting to Payment-2 and Skipping Payment-1')
          this.updateUrlPath(12, `#${this.steps[this.formPosition + 12]?.identifier?.toLowerCase()}`, this.steps[this.formPosition + 12]?.identifier);
          }else{
            console.log('Rerouting...')
            this.updateUrlPath(savedIndex, savedPath, savedNextStep?.identifier);
          }

          this.savedNextStep = null;
          this.savedIndex = null;
          return;
        }
      }
      console.log('index == '+index);
      const nextStep = this.steps[this.formPosition + index];
      const currentStep = this.steps[this.formPosition];
      const identifier = this.steps[this.formPosition + index]?.identifier;
      const path = `${search}#${identifier?.toLowerCase()}`;
      if (initialHit) {
        this.updateUrlPath(index, path, identifier);
        return;
      }


      if((nextStep?.identifier === 'Payment-1' || currentStep === 'Insurance-3') && (this.renderedPayment?.is_type === 'triumph_pay'
       &&  Number(this.renderedPayment?.triumph_pay_select_carrier_rate)) > 0 && this.isTriumphPayAllowed){
        console.log('Skipping Payment-1 nextStep')
        await this.updateUrlPath(2, `#${this.steps[this.formPosition + 2]?.identifier?.toLowerCase()}`, this.steps[this.formPosition + 2]?.identifier);
      }else{
      let canHitNextStep = await this.determineIfCanHitNextStep(currentStep, nextStep);
      console.log('CAN HIT NEXT STEP', canHitNextStep)
      // Find request payload body -- if exists submit update to onboarding packet
      // and have the logic to call nextStepPatch
      const updatePacketResponse = await this.updatePacket(
        currentStep,
        canHitNextStep
      );
      // the return of this response is the response from the nextStep patch
      // 200 should move the user to the next step
      // anything else, DONT let the user move forward and through a toast error
      if (updatePacketResponse?.status === 200) {
        // return updatePacketResponse;
        console.log(updatePacketResponse)
        // if the packet is complete then we need to move on.  This could be because
        // the issuer doesn't require some of the final steps.
        if(updatePacketResponse.data?.status == 'complete'){
          console.log('onboarding packet complete; redirect user')
          const redirectUrl = localStorage.getItem("redirect_url_after_sigin");
          if (redirectUrl) {
            console.log('redirectUrl', redirectUrl)
            let redirectAfterSignIn = JSON.parse(
              localStorage.getItem("redirect_url_after_sigin")
            );

            if (redirectAfterSignIn) {
              localStorage.removeItem("redirect_url_after_sigin");
              return this.$router.push(redirectAfterSignIn);
            }
          }
          // The return from above will block us from getting here; if we
          // get here, we just need to take the user home
          return this.$router.push({
            name: "Carrier Onboarding Packet Status",
            params: { id: this.onboardingPacket.id },
          });
        } else {
          await this.updateUrlPath(index, path, identifier);
        }
      } else {
        this.buttonLoading = false;
        toastResponse(this, updatePacketResponse, null);
      }

      }

    },*/

    // updateUrlPath(index, path, identifier) {
    //   console.log('updateUrlPath')
    //   console.log(index, path, identifier)
    //   this.buttonLoading = false;
    //   this.stepName = identifier;
    //   this.formPosition += index;
    //   window.history.pushState(null, null, path);
    // },
    // TODO -- rewrite this method.
    backStep2() {},
    /* backStep() {
      console.log('BackStep!')
      const { company_question_sections } = this.$store.state.carriers.carrierData;
      const { broker_connect_channels } = this.$store.state.onboardingPacket;
      // const { auto_skip_stage_seven } = this.$store.state.carriers.carrierData;
      let auto_skip_stage_six = this.auto_skip_stage_six;
      let auto_skip_stage_seven = this.auto_skip_stage_seven;
      const { auto_skip_stage_eight } = this.$store.state.carriers.carrierData;

      const { search } = window.location;

      let updatedHash;
      if (this.$store.state.integrationsStep) {
        // const lastStep = this.steps.length;
        // this.stepName = this.steps[lastStep]?.identifier;
        // updatedHash = this.steps[lastStep]?.identifier?.toLowerCase();
        // this.formPosition = lastStep;
        this.$store.commit("isIntegrationsStep", false);
      }
      if (
          this.stepName === "Contract-1" &&
          (!broker_connect_channels.length || auto_skip_stage_eight) &&
          (!company_question_sections.length || auto_skip_stage_seven) &&
          auto_skip_stage_six == true
      ) {
        this.formPosition -= 7;
        updatedHash =
          this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      } else if (
          this.stepName === "Contract-1" &&
          (!broker_connect_channels.length || auto_skip_stage_eight) &&
          (!company_question_sections.length || auto_skip_stage_seven)
      ) {
        console.log('its here?')
        let skipCount =
          this.$store.state.payments.payment_type === "factoring" ||
          !!this.$store.state.carriers.carrierData.payment_method
            ? 5
            : 4;
        this.formPosition -= skipCount;
        updatedHash =
          this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      }else if(this.stepName === "Payment-2" && this.renderedPayment?.is_type === 'triumph_pay'
      &&  Number(this.renderedPayment?.triumph_pay_select_carrier_rate) > 0 && this.isTriumphPayAllowed
      // && this.$store.state.payments.payment_type !== "factoring"
      ){
        console.log('Skipping payment-1')
        const position = this.formPosition;
        updatedHash =this.steps[position - 2]?.identifier?.toLowerCase();
        this.stepName = this.steps[position - 2]?.identifier;
        this.formPosition -= 2;
      }else if (
        this.stepName === "Contract-1" &&
        (!broker_connect_channels.length || auto_skip_stage_eight) &&
        (company_question_sections?.length > 0 || !auto_skip_stage_seven)
      ) {
        this.stepName = this.steps[this.formPosition - 2]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
        this.formPosition -= 2;
      } else if(this.stepName === "Integrations" && this.isActiveTruckerTool){
        this.$store.commit('integrations/setActiveTruckerTools', false);

      } else if (
          this.stepName === "Integrations" &&
          (!company_question_sections.length || auto_skip_stage_seven) &&
          auto_skip_stage_six == true
      ) {
        this.formPosition -= 6;
        updatedHash =
          this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      } else if (
          this.stepName === "Integrations" &&
          (!company_question_sections.length || auto_skip_stage_seven)
      ) {
        this.$store.commit(
          "questions/setSection",
          this.$store.state.questions.total_sections
        );
        this.$store.commit(
          "questions/setSectionIndex",
          this.$store.state.questions.total_sections - 1
        );
        console.log('factoring 2!')
        let skipCount =
          this.$store.state.payments.payment_type === "factoring" ||
          !!this.$store.state.carriers.carrierData.payment_method
            ? 4
            : 3;
        this.formPosition -= skipCount;
        updatedHash =
          this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      }

      else if(this.stepName === 'Insurance-4' && !this.hasFileAuto && this.hasFileCargo){
        console.log('BackStep to Insurance-1 (has not file auto).', this.formPosition)
        this.formPosition -= 3;
        updatedHash = this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      }
      else if (
          this.stepName === "Questions" &&
          this.$store.state.questions.section_index === 0 &&
          auto_skip_stage_six == true
      ) {
        this.formPosition -= 4;
        updatedHash =
          this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      }
      else if (
          this.stepName === "Questions" &&
          this.$store.state.questions.section_index === 0
      ) {
        console.log('factoring 3!')
        let skipCount =
          this.$store.state.payments.payment_type === "factoring" ||
          !!this.$store.state.carriers.carrierData.payment_method
            ? 3
            : 2;
        this.formPosition -= skipCount;
        updatedHash =
          this.steps[this.formPosition]?.identifier?.toLowerCase();
        this.stepName = this.steps[this.formPosition]?.identifier;
      } else if (
        this.stepName === "Contract-2" &&
        !broker_connect_channels.length &&
        !company_question_sections.length &&
        !this.$store.state.firstTime["Contract"]
      ) {
        this.stepName = this.steps[this.formPosition - 6]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 6]?.identifier?.toLowerCase();
        this.formPosition -= 6;
      } else if (
        this.stepName === "Contract-2" &&
        !broker_connect_channels.length &&
        company_question_sections.length &&
        !this.$store.state.firstTime["Contract"]
      ) {
        this.stepName = this.steps[this.formPosition - 3]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 3]?.identifier?.toLowerCase();
        this.formPosition -= 3;
      } else if (
        this.stepName === "Contract-2" &&
        broker_connect_channels.length &&
        !this.$store.state.firstTime["Contract"]
      ) {
        this.stepName = this.steps[this.formPosition - 2]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
        this.formPosition -= 2;
      } else if (
        //  TODO Validate with TIM
     //if (this.stepName === "Contract-3" && this.$store.state.firstTime) {
     //   this.stepName = this.steps[this.formPosition - 2]?.identifier;
     //   updatedHash =
     //     this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
     //   this.formPosition -= 2;
     // }
        this.stepName === "Contract-2" &&
        !this.$store.state.firstTime["Contract"]
      ) {
        // TODO -- this logic is incorrect
        this.stepName = this.steps[this.formPosition - 2]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
        this.formPosition -= 2;
      } else if (
        this.stepName === "Questions" &&
        this.$store.state.questions.section_index > 0
      ) {
        this.$store.commit(
          "questions/setSection",
          this.$store.state.questions.section - 1
        );
        this.$store.commit(
          "questions/setSectionIndex",
          this.$store.state.questions.section_index - 1
        );
      } else if (
        (this.stepName === "Insurance-3" &&
          !this.$store.state.firstTime["Insurance"]) ||
        (this.stepName === "Insurance-3" &&
          this.$store.state.carriers.carrierData.insurance_policies?.length >
            0) ||
        (this.stepName === "Payment-1" &&
          !this.$store.state.firstTime["Insurance"])
      ) {
        this.stepName = this.steps[this.formPosition - 2]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
        this.formPosition -= 2;
      } else if (this.stepName === "Payment-4") {
        this.stepName = this.steps[this.formPosition - 2]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
        this.formPosition -= 2;
      } else if (
        !this.$store.state.firstTime["Certifications"] &&
        this.stepName === "Insurance-1"
      ) {
        this.stepName = this.steps[this.formPosition - 2]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 2]?.identifier?.toLowerCase();
        this.formPosition -= 2;
      } else if (this.formPosition > 0) {
        this.stepName = this.steps[this.formPosition - 1]?.identifier;
        updatedHash =
          this.steps[this.formPosition - 1]?.identifier?.toLowerCase();
        this.formPosition -= 1;
      }
      if (updatedHash) {
        window.history.pushState(null, null, `${search}#${updatedHash}`);
      }
    }, */
    setIntegrationStep(path, value) {
      this.$store.commit('updateNestedField', { path, value });
    },
    // skipStep(index) {
    //   this.stepName = this.steps[index]?.identifier;
    //   this.formPosition = index;
    // },
    skipStep() {
      // this.stepName = this.steps[index]?.identifier;
      // this.formPosition = index;
    },
    updateField(name, value) {
      this.$store.commit('updateField', { name, value });
    },
    beginningStep() {
      this.$store.dispatch('formRoutes/redirectToBeginningStep');
      window.location.href = `${process.env.ENV_URL}/onboarding/carrier/my-profile`;
    },
    async getUserStatus() {
      const { users } = this.$store.state;
      if (!users.currentUser) {
        await this.$store.dispatch(
          'authorizations/checkUserAndOnboardingStatus'
        );
      }
      // TODO -- add some sort of loading state while info is being fetch
      // -- see how to get this info quicker (grabbing information on router before the page hits maybe)
      const packetRes = await this.$store.dispatch(
        'onboardingPacket/getOnboardingPacket'
      );
      if ([200, 201].includes(packetRes.status)) {
        const res = await this.$store.dispatch(
          'onboardingPacket/getOnboardingPacketById',
          { id: packetRes.data[0]?.id }
        );
        await this.$store.dispatch(
          'authorizations/setConnectionInfo',
          packetRes.data[0]
        );
        if ([200, 201].includes(res.status)) {
          // this.$store.commit("updateCarrierData", res.data);
        } else {
          // HANDLE IF ONBOARDING INFO ERROR
        }
      }
    },
  },
  setup() {
    const showSaveModal = ref(false);
    const openSaveModal = () => {
      showSaveModal.value = true;
    };
    const onCloseSaveModal = () => {
      showSaveModal.value = false;
    };
    return {
      showSaveModal,
      openSaveModal,
      onCloseSaveModal,
    };
  },
};
</script>
<style scoped>
.scrollbar-visible {
  scrollbar-gutter: stable;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}
.logo {
  width: 122px;
  height: auto;
}
.tablet-desktop-container {
  @apply md:max-w-3xl md:rounded-md md:border md:border-light-gray md:px-4 md:py-8 md:shadow-primary;
  min-height: calc(100vh - 16px);
}

@media only screen and (min-width: 768px) {
  .main-container {
    /* padding-top: 5rem; */
    padding-bottom: 16px !important;
  }
  .pb-test {
    padding-top: 5rem;
  }

  .tablet-desktop-container {
    /*  Removing padding-top and padding-bottom values from total container (5rem and 16px) Using main-container as reference */
    min-height: calc(100vh - 5rem - 16px);
    position: relative;
  }

  .tablet-desktop-container > .content-container {
    margin-bottom: 79px;
  }
}
@media (max-width: 767px) {
  .text-1md.invisible {
    width: 0px !important;
  }
}

@media (max-width: 500px) {
  .small-sm-text {
    font-size: 10px !important;
  }
}

@media (min-width: 360px) {
  .custom\:pr-5 {
    padding-right: 1.25rem;
  }
}
</style>
